import './App.css'
import React from 'react'
import { RouterProvider } from 'react-router'

import '@rainbow-me/rainbowkit/styles.css'
import Loading from '@/components/Loading'
import { AppProviders } from '@/context'

import ErrorBoundary from './components/ErrorBoundary'
import { WebSocketProvider } from './context/websocket-context'
import router from './router'
import { useLoading } from './utils'

const App: React.FC = () => {
  const { isLoading } = useLoading()

  return (
    <AppProviders>
      <ErrorBoundary>
        <WebSocketProvider>
          {isLoading ? <Loading /> : <RouterProvider router={router} />}
        </WebSocketProvider>
      </ErrorBoundary>
    </AppProviders>
  )
}
App.displayName = 'App'
export default App
